import React from 'react'
import { TbBackground } from 'react-icons/tb'

const Footer = ()=>{
    return (
        <div id="footer" >
           <center> <h4> &copy;<span id="currentYear">2025</span> kyuma. All rights reserved.</h4></center>
        </div>
        
    )
}

export default Footer